export default __webpack_public_path__ + "static/media/step5.43b588a8.svg";